import {
  symbol,
  symbolCircle,
  symbolCross,
  symbolDiamond,
  symbolSquare,
  symbolStar,
  symbolTriangle,
  symbolWye,
} from 'd3-shape';

export interface DeviceTypeConfig {
  color: string;
  symbolType: string;
}

export const DEVICE_TYPE_CONFIG: Record<string, DeviceTypeConfig> = {
  router: { color: '#1677ff', symbolType: 'diamond' },
  switch: { color: '#52c41a', symbolType: 'square' },
  firewall: { color: '#ff4d4f', symbolType: 'triangle' },
  server: { color: '#722ed1', symbolType: 'square' },
  workstation: { color: '#13c2c2', symbolType: 'circle' },
  wireless: { color: '#faad14', symbolType: 'star' },
  accesspoint: { color: '#faad14', symbolType: 'star' },
  printer: { color: '#fa8c16', symbolType: 'cross' },
  network: { color: '#2f54eb', symbolType: 'wye' },
  unknown: { color: '#8c8c8c', symbolType: 'circle' },
};

const D3_SYMBOL_MAP: Record<string, Parameters<typeof symbol>[0]> = {
  circle: symbolCircle,
  cross: symbolCross,
  diamond: symbolDiamond,
  square: symbolSquare,
  star: symbolStar,
  triangle: symbolTriangle,
  wye: symbolWye,
};

export const getDeviceTypeConfig = (deviceType: string): DeviceTypeConfig => {
  const key = deviceType?.toLowerCase() ?? 'unknown';
  return DEVICE_TYPE_CONFIG[key] ?? DEVICE_TYPE_CONFIG.unknown;
};

export const getDeviceSymbolPath = (symbolType: string): string => {
  const sym = D3_SYMBOL_MAP[symbolType] ?? symbolCircle;
  return symbol().type(sym).size(96)() ?? '';
};
